<div class="dangky-hoc-container">
  <as-split unit="pixel"
            direction="horizontal"
            [disabled]="false"
            [gutterSize]="10"
            style="height: 100%; width: 100%">

    <!-- Left Panel - Danh sách học phí -->
    <as-split-area size="600" style="background-color:#f8f9fa; height: 100%">
      <div class="card fee-card">
        <div class="card-header bg-gradient-dark text-white">
          <div class="d-flex align-items-center">
            <i class="fas fa-dollar-sign mr-2"></i>
            <strong>{{'Danh sách học phí' | translate}}</strong>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="data-content-wrapper">
            <!-- Vertical Toolbar -->
            <div class="vertical-toolbar" *ngIf="quyen_them===true">
              <button class="toolbar-btn btn-add" (click)="adddata()" title="Thêm học phí">
                <i class="fas fa-plus"></i>
              </button>
              <button class="toolbar-btn btn-edit" (click)="editdata_dangky()" title="Sửa học phí">
                <i class="fas fa-edit"></i>
              </button>
              <button class="toolbar-btn btn-delete" (click)="deleterow_dangky()" title="Xóa học phí">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>

            <!-- Table Wrapper -->
            <div class="table-wrapper-horizontal">
              <table class="table table-hover table-sm mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="min-width:80px;width:80px;text-align:center">STT</th>
                    <th style="min-width:130px;width:130px">Ngày tạo</th>
                    <th style="min-width:130px;width:130px">Ngày bắt đầu</th>
                    <th style="min-width:200px;width:200px">Khóa học</th>
                    <th style="min-width:150px;width:150px;text-align:right">Số tiền</th>
                    <th style="min-width:150px;width:150px;text-align:right">Giảm</th>
                    <th style="min-width:150px;width:150px;text-align:right">Học phí thu</th>
                    <th style="min-width:120px;width:120px;text-align:center">Số buổi</th>
                    
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let u of datas" 
                      (dblclick)="editdata(u)" 
                      [ngClass]="{'rowItem_Selected': u.Id==tId}" 
                      (click)="selected(u)"
                      class="data-row">
                    <td style="text-align:center">
                      <span class="badge badge-secondary">{{u.STT}}</span>
                    </td>
                    <td>
                      <small class="text-muted">{{u.Created | date:'dd/MM/yyyy'}}</small>
                    </td>
                    <td>
                      <small class="text-primary">{{u.NgayDangKy | date:'dd/MM/yyyy'}}</small>
                    </td>
                    <td>
                      <strong>{{u.KhoaHoc}}</strong>
                    </td>
                    <td style="text-align:right">
                      <span class="amount-text">{{u.GiaPhi | number:'1.0-0'}}</span>
                    </td>
                    <td style="text-align:right">
                      <span class="discount-text">{{u.DuocGiam | number:'1.0-0'}}</span>
                    </td>
                    <td style="text-align:right">
                      <span class="total-text">{{u.ThucThu | number:'1.0-0'}}</span>
                    </td>
                    <td style="text-align:center">
                      <span class="badge badge-info">{{u.SoBuoi}}</span>
                    </td>
                  
                  </tr>

                  <tr *ngIf="!datas || datas.length === 0">
                    <td colspan="9" class="text-center text-muted py-4">
                      <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                      Chưa có dữ liệu học phí
                    </td>
                  </tr>
                </tbody>

                <!-- Summary Footer -->
                <tfoot *ngIf="datas && datas.length > 0" class="summary-footer bg-light">
                  <tr>
                    <td colspan="4" class="text-right">
                      <strong><i class="fas fa-calculator mr-2"></i>TỔNG CỘNG:</strong>
                    </td>
                    <td class="text-right">
                      <span class="summary-amount">{{tong_giaphi | number:'1.0-0'}}</span>
                    </td>
                    <td class="text-right">
                      <span class="summary-discount">{{tong_giamgia | number:'1.0-0'}}</span>
                    </td>
                    <td class="text-right">
                      <span class="summary-total">{{tong_thucthu | number:'1.0-0'}}</span>
                    </td>
                    <td class="text-center">
                      <span class="summary-sessions">{{tong_sobuoi | number}}</span>
                    </td>
                    
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div class="card-footer bg-white border-top" *ngIf="totalItems >= 10">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
              <a class="page-link" (click)="setPage(1)"><<</a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
              <a class="page-link" (click)="setPage(currentPage - 1)"><</a>
            </li>
            <li class="page-item" *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
              <a class="page-link" (click)="setPage(page.Id)">{{page.Id}}</a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
              <a class="page-link" (click)="setPage(currentPage + 1)">></a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
              <a class="page-link" (click)="setPage(totalPages)">>></a>
            </li>
            <li class="page-item">
              <input type="number" class="form-control form-control-sm page-size-input" 
                     [(ngModel)]="pageSize" (blur)="search1()" />
            </li>
            <li class="page-item">
              <span class="page-link"><strong>Tổng: {{totalItems | number}}</strong></span>
            </li>
          </ul>
        </div>
      </div>
    </as-split-area>

    <!-- Right Panel - Danh sách thu tiền -->
    <as-split-area size="*" style="background-color:#f8f9fa; height: 100%">
      <div class="card payment-card">
        <div class="card-header bg-gradient-dark text-white">
          <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
            <div class="d-flex align-items-center">
              <i class="fas fa-receipt mr-2"></i>
              <strong>{{'Danh sách thu tiền' | translate}}</strong>
            </div>
            <div *ngIf="quyen_them===true" class="ml-auto">
              <div class="btn-group" dropdown>
                <button class="btn btn-sm btn-light dropdown-toggle" type="button" dropdownToggle>
                  <i class="fa fa-print mr-1"></i>
                  In ấn
                </button>
                <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                  <a class="dropdown-item" (click)="export('pdf')">
                    <em class="mr-2 fas fa-print text-info"></em>{{'In phiếu thu' | translate}}
                  </a>
                  <a class="dropdown-item" (click)="export('xlsx')">
                    <em class="mr-2 fas fa-file-excel text-success"></em>{{'In excel' | translate}}
                  </a>
                  <a class="dropdown-item" (click)="export2('pdf')">
                    <em class="mr-2 fas fa-print text-info"></em>{{'In phiếu thu (2 liên)' | translate}}
                  </a>
                  <a class="dropdown-item" (click)="export2('xlsx')">
                    <em class="mr-2 fas fa-file-excel text-success"></em>{{'In excel (2 liên)' | translate}}
                  </a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" (click)="tuychinhmaubaocao()">
                    <em class="mr-2 fas fa-broom text-warning"></em>Chỉnh sửa mẫu phiếu
                  </a>
                  <a class="dropdown-item" (click)="tuychinhmaubaocao2()">
                    <em class="mr-2 fas fa-broom text-warning"></em>Chỉnh sửa mẫu 2 liên
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="data-content-wrapper">
            <!-- Vertical Toolbar -->
            <div class="vertical-toolbar" *ngIf="quyen_them===true">
              <button class="toolbar-btn btn-add" (click)="adddata_donghoc()" title="Thêm phiếu thu">
                <i class="fas fa-plus"></i>
              </button>
              <button class="toolbar-btn btn-edit" (click)="editdata_donghoc()" title="Sửa phiếu thu">
                <i class="fas fa-edit"></i>
              </button>
              <button class="toolbar-btn btn-delete" (click)="deleterow_donghoc()" title="Xóa phiếu thu">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>

            <!-- Table Wrapper -->
            <div class="table-wrapper-horizontal">
              <table class="table table-hover table-sm mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="min-width:80px;width:80px;text-align:center">STT</th>
                    <th style="min-width:130px;width:130px">Ngày tạo</th>
                    <th style="min-width:130px;width:130px">Ngày nộp</th>
                    <th style="min-width:180px;width:180px">Quyển</th>
                    <th style="min-width:150px;width:150px">Số phiếu</th>
                    <th style="min-width:180px;width:180px;text-align:right">Số tiền</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let u of data2s" 
                      (dblclick)="editdata2(u)" 
                      [ngClass]="{'rowItem_Selected': u.Id==tId2}" 
                      (click)="selected2(u)"
                      class="data-row">
                    <td style="text-align:center">
                      <span class="badge badge-secondary">{{u.STT}}</span>
                    </td>
                    <td>
                      <small class="text-muted">{{u.Created | date:'dd/MM/yyyy'}}</small>
                    </td>
                    <td>
                      <small class="text-success">{{u.NgayNop | date:'dd/MM/yyyy'}}</small>
                    </td>
                    <td>
                      <strong>{{u.QuyenSo}}</strong>
                    </td>
                    <td>
                      <span class="badge badge-primary">{{u.SoPhieu}}</span>
                    </td>
                    <td style="text-align:right">
                      <span class="total-text">{{u.SoTien | number:'1.0-0'}}</span>
                    </td>
                  </tr>

                  <tr *ngIf="!data2s || data2s.length === 0">
                    <td colspan="6" class="text-center text-muted py-4">
                      <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                      Chưa có dữ liệu thu tiền
                    </td>
                  </tr>
                </tbody>

                <!-- Summary Footer -->
                <tfoot *ngIf="data2s && data2s.length > 0" class="summary-footer bg-light">
                  <tr>
                    <td colspan="5" class="text-right">
                      <strong><i class="fas fa-calculator mr-2"></i>TỔNG CỘNG:</strong>
                    </td>
                    <td class="text-right">
                      <span class="summary-total">{{tong_tien | number:'1.0-0'}}</span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div class="card-footer bg-white border-top" *ngIf="totalItem2s >= 10">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [ngClass]="{disabled: currentPage2 === 1}">
              <a class="page-link" (click)="setPage2(1)"><<</a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage2 === 1}">
              <a class="page-link" (click)="setPage2(currentPage2 - 1)"><</a>
            </li>
            <li class="page-item" *ngFor="let page of page2s" [ngClass]="{active: currentPage2 === page.Id}">
              <a class="page-link" (click)="setPage2(page.Id)">{{page.Id}}</a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage2 === totalPage2s}">
              <a class="page-link" (click)="setPage2(currentPage2 + 1)">></a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage2 === totalPage2s}">
              <a class="page-link" (click)="setPage2(totalPage2s)">>></a>
            </li>
            <li class="page-item">
              <input type="number" class="form-control form-control-sm page-size-input" 
                     [(ngModel)]="pageSize2" (blur)="search21()" />
            </li>
            <li class="page-item">
              <span class="page-link"><strong>Tổng: {{totalItem2s | number}}</strong></span>
            </li>
          </ul>
        </div>
      </div>
    </as-split-area>
  </as-split>
</div>

<!-- Modals -->
<bs-modal #mdDangKyGoiHoc class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDangKyGoiHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-dangkygoihocedit #dangkygoihocedit (save)="saveModalDangKy($event)"></app-daotao-dangkygoihocedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdDongHoc class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDongHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-donghocedit #donghocedit (save)="saveModalDongHoc($event)"></app-daotao-donghocedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdDatLich class="modal fade show in" [cssClass]="'modal7'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDatLich.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-datlichthuhocphiedit #datlichedit (save)="saveModalDatLich($event)"></app-daotao-datlichthuhocphiedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #modaltuychinhmaubc class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="modaltuychinhmaubc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-quantri-tuychinhmaubcedit #dtsuamaubaocao></app-quantri-tuychinhmaubcedit>
  </bs-modal-body>
</bs-modal>
